import { SolidifyableData } from "../../../core/data/SolidifyableData";
import { GameConstants } from "../../controller/net/constant/GameConstants";
/**
 * ClientData.ts
 */
export class ClientData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        this.activeBalanceType = this.data.getString(GameConstants.PROPERTY_ACTIVE_BALANCE);
        this.postWager = this.data.getBool(GameConstants.PROPERTY_POST_WAGER);
    }
    getClient() {
        return this.data.toObject();
    }
    getActiveBalanceType() {
        return this.activeBalanceType;
    }
    isPostWager() {
        return this.postWager;
    }
}
//# sourceMappingURL=ClientData.js.map